/* eslint-disable no-unused-vars */
import $ from "jquery";
import slick from "slick-carousel";
/* eslint-enable no-unused-vars */

function updateSliderImage() {
  if (!$(".promo-banner").length) {
    return;
  }
  const screenWidth = $(window).width();
  $(".banner-img img").each(function() {
    const img = $(this);
    const defaultImage = img.data("banner-image");
    const smallImage = img.data("banner-image-small");

    const imgSrc = screenWidth < 992 ? smallImage : defaultImage;
    if (img.attr("src") !== imgSrc) {
      img.attr("src", imgSrc);
    }
  });
}

const BannerCarousel = () => {
  $(document).ready(() => {
    $(".promo-banner").slick({
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      fade: true,
      centerMode: true,
      speed: 500,
      nextArrow: "<button class='slick-next'></button>",
      prevArrow: "<button class='slick-prev'></button>"
    });
    updateSliderImage();
  });

  $(window).resize(() => {
    updateSliderImage();
  });
};

export default BannerCarousel;
